import { render, staticRenderFns } from "./nav-menu.vue?vue&type=template&id=23a49aad&"
import script from "./nav-menu.vue?vue&type=script&lang=js&"
export * from "./nav-menu.vue?vue&type=script&lang=js&"
import style0 from "./nav-menu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports